var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, HStack, Flex, Text, Icon, FormControl, FormLabel, Input, FormHelperText, Checkbox, Button, Select, Tag, TagLabel } from '@chakra-ui/react';
import { observer, Observer } from 'mobx-react';
import React from 'react';
import { StoreContext } from '../uistore/Rootstore';
import { BaseDialog } from './BaseDialog';
import { BiText } from '@react-icons/all-files/bi/BiText';
import { MdCheckBox } from '@react-icons/all-files/md/MdCheckBox';
import { MdColorize } from '@react-icons/all-files/md/MdColorize';
import { ChoiceType, Comparator, ConditionType, SchemaItemType } from '@@/Schema';
import { MdList } from '@react-icons/all-files/md/MdList';
import { FiPlus } from '@react-icons/all-files/fi/FiPlus';
import { GrDrag } from '@react-icons/all-files/gr/GrDrag';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { MdDelete } from '@react-icons/all-files/md/MdDelete';
import { FaCalendar } from '@react-icons/all-files/fa/FaCalendar';
import { AppColor } from '../const/AppDefaults';
import { SelectMemberDialog } from './SelectMemberDialog';
import { ScaleLoader } from 'react-spinners';
import { AiOutlineNumber } from '@react-icons/all-files/ai/AiOutlineNumber';
import { FaIdCard } from '@react-icons/all-files/fa/FaIdCard';
import { MdClear } from '@react-icons/all-files/md/MdClear';
import { GrFormEdit } from '@react-icons/all-files/gr/GrFormEdit';
import { ALLViewer } from '@@/Annotation';
import { LetrwingCrypto } from '@@/LetrwingCommonCrypto';
import { MdLink } from '@react-icons/all-files/md/MdLink';
import { FaUser } from '@react-icons/all-files/fa/FaUser';
import { MdEdit } from '@react-icons/all-files/md/MdEdit';
import { HiDocument } from '@react-icons/all-files/hi/HiDocument';
import { RiTableLine } from '@react-icons/all-files/ri/RiTableLine';
import { MdMenu } from '@react-icons/all-files/md/MdMenu';
import { testIsMobile } from '@@/Util';
import { Templates } from '../uistore/TemplateStore';
import { Select as ChakreSelect } from "chakra-react-select";
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { GrConnect } from '@react-icons/all-files/gr/GrConnect';
import { RuleParamUICondition, RuleParamUIConditionParam } from '../uistore/RuleBuilderStore';
import DatePicker from "react-datepicker";
import { SketchPicker } from 'react-color';
let TemplateSelector = class TemplateSelector extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            id: []
        };
    }
    render() {
        const keys = Object.keys(Templates);
        const values = Object.values(Templates);
        const opts = [];
        for (let i = 0; i < keys.length; i++) {
            opts.push({ label: values[i], value: keys[i] });
        }
        return React.createElement(Flex, { w: '400px', alignItems: 'center' },
            React.createElement(Box, { w: '300px' },
                React.createElement(ChakreSelect, { selectedOptionStyle: "check", options: opts, isSearchable: true, value: opts.filter((lt) => {
                        if (this.state.id.indexOf(lt.value) != -1) {
                            return true;
                        }
                        return false;
                    }).map((lt) => lt), onChange: (e) => {
                        this.setState({ id: [e.value] });
                    }, placeholder: 'Select Template' })),
            React.createElement(Box, { ml: '5px' }, this.state.id.length > 0 && React.createElement(Icon, { w: '40px', h: '30px', as: MdClear, _hover: { cursor: 'pointer' }, title: 'Clear Selection', onClick: () => {
                    this.setState({ id: [] });
                } })));
    }
};
TemplateSelector.contextType = StoreContext;
TemplateSelector = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], TemplateSelector);
let SchemaDialog = class SchemaDialog extends React.Component {
    addType(type) {
        const rstore = this.context;
        let orderinex = 0;
        if (rstore.schemaStore.schemaitems.length) {
            while (orderinex === 0) {
                orderinex = Math.random() * (1 -
                    rstore.schemaStore.schemaitems[rstore.schemaStore.schemaitems.length - 1].orderindex) + rstore.schemaStore.schemaitems[rstore.schemaStore.schemaitems.length - 1].orderindex;
            }
        }
        else {
            while (orderinex === 0) {
                orderinex = Math.random();
            }
        }
        const item = {
            id: LetrwingCrypto.getUUID() + '',
            name: 'Item ' + (rstore.schemaStore.itemindex),
            orderindex: orderinex,
            required: false,
            type: type
        };
        rstore.schemaStore.itemindex++;
        rstore.schemaStore.addSchemaItem(item);
    }
    dialogBodyMobile() {
        const rstore = this.context;
        return React.createElement(Box, { pos: 'relative', overflow: 'auto', maxH: (window.innerHeight - 50) + "px" },
            React.createElement(Flex, { w: '100%', align: 'center' },
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, { htmlFor: 'tabname', fontSize: '12px' }, "Name"),
                    React.createElement(Input, { size: 'xs', value: rstore.schemaStore.name, onChange: (e) => rstore.schemaStore.setName(e.currentTarget.value), id: 'tabname' })),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, { htmlFor: 'apicode', fontSize: '12px' }, "Api Code"),
                    React.createElement(Input, { size: 'xs', value: rstore.schemaStore.apicode, onChange: (e) => rstore.schemaStore.addApiCode(e.currentTarget.value), id: 'apicode' })),
                React.createElement(Viewers, null),
                React.createElement(Flex, { ml: '3px', w: '100%', justify: 'center', align: 'center' }, rstore.schemaStore.saving && React.createElement(ScaleLoader, { color: 'green' }))),
            rstore.mainSchemaStore.schemas.size > 0 && React.createElement(Flex, { w: '100%', align: 'center', mt: '5px', mb: '5px' },
                React.createElement(Observer, null, () => React.createElement(Checkbox, { size: 'sm', disabled: rstore.schemaStore.editmode, checked: rstore.schemaStore.derived, defaultChecked: rstore.schemaStore.derived, onChange: (e) => rstore.schemaStore.setDervied(e.currentTarget.checked) }, "Derived Schema")),
                rstore.schemaStore.derived && React.createElement(Select, { size: 'sm', ml: '20px', disabled: rstore.schemaStore.editmode, width: '250px', value: rstore.schemaStore.derviedschema, placeholder: 'Select schema', onChange: (e) => {
                        rstore.schemaStore.dervivedsch = rstore.mainSchemaStore.schemas.get(e.currentTarget.value);
                        if (!rstore.schemaStore.dervivedsch) {
                            return;
                        }
                        rstore.schemaStore.setDervicedSchema(e.currentTarget.value);
                    } }, Array.from(rstore.mainSchemaStore.schemas.values()).filter((sh) => sh.parentschema === undefined)
                    .slice()
                    .map((tab) => React.createElement("option", { key: tab.id, value: tab.id }, tab.name)))),
            React.createElement(Icon, { w: '20px', h: '20px', onClick: () => rstore.schemaStore.setShowTypesMenu(true), color: AppColor.TopBarIconColor, as: MdMenu, mr: '10px' }),
            React.createElement(Box, { pos: 'absolute', top: "20px", left: '1%', bg: 'white', className: rstore.activeMemberStore.activecontactid !== '' ? 'slide-left' : '', zIndex: 1000 }, this.renderTypesPanel()),
            this.renderColumnPanel(),
            React.createElement(Box, { pos: 'absolute', top: "20px", right: '1%', bg: 'white', className: rstore.activeMemberStore.activecontactid !== '' ? 'slide-right' : '', zIndex: 1000 }, this.renderDetailsPanel()));
    }
    renderColumnPanel() {
        const rstore = this.context;
        const items = rstore.schemaStore.getSchemaItems();
        return React.createElement(Box, null,
            React.createElement(Flex, { h: '20px', w: '100%' },
                React.createElement(Text, { fontWeight: 'bold', fontSize: '12px' }, "Columns")),
            React.createElement(Observer, null, () => React.createElement(Box, { ml: '5px', h: (window.innerHeight - 400) + "px", maxH: (window.innerHeight - 400) + "px", overflow: 'auto' },
                items.length === 0 && React.createElement(Box, { key: 'no_columns', onDragOver: () => {
                    }, h: '100px', w: '100%' }),
                items.length > 0 && items.map((item, index) => {
                    let label = "";
                    let icon = undefined;
                    if (item.type === SchemaItemType.Text) {
                        label = "Text";
                        icon = React.createElement(Icon, { as: BiText });
                    }
                    else if (item.type === SchemaItemType.Number) {
                        label = "Number";
                        icon = React.createElement(Icon, { as: AiOutlineNumber });
                    }
                    else if (item.type === SchemaItemType.ID) {
                        label = "ID";
                        icon = React.createElement(Icon, { as: FaIdCard });
                    }
                    else if (item.type === SchemaItemType.Boolean) {
                        label = "Checkbox";
                        icon = React.createElement(Icon, { as: MdCheckBox });
                    }
                    else if (item.type === SchemaItemType.Color) {
                        label = "Color";
                        icon = React.createElement(Icon, { as: MdColorize });
                    }
                    else if (item.type === SchemaItemType.Choice) {
                        label = "Choice";
                        icon = React.createElement(Icon, { as: MdList });
                    }
                    else if (item.type === SchemaItemType.Date) {
                        label = "Date";
                        icon = React.createElement(Icon, { as: FaCalendar });
                    }
                    else if (item.type === SchemaItemType.FormInput) {
                        label = "Form Input";
                        icon = React.createElement(Icon, { as: MdEdit });
                    }
                    else if (item.type === SchemaItemType.URL) {
                        label = "Link";
                        icon = React.createElement(Icon, { as: MdLink });
                    }
                    else if (item.type === SchemaItemType.UserChoice) {
                        label = "User";
                        icon = React.createElement(Icon, { as: FaUser });
                    }
                    else if (item.type === SchemaItemType.Objects) {
                        label = "Objects";
                        icon = React.createElement(Icon, { as: HiDocument });
                    }
                    else if (item.type === SchemaItemType.List) {
                        label = "List";
                        icon = React.createElement(Icon, { as: RiTableLine });
                    }
                    else if (item.type === SchemaItemType.Remote) {
                        label = "Remote Item";
                        icon = React.createElement(Icon, { as: GrConnect });
                    }
                    const adddragzone = items.length > 1;
                    return React.createElement(Box, { pos: 'relative', minH: '100px', key: item.id + '_mainitem', w: '100%' },
                        React.createElement(Flex, { pos: 'absolute', top: '32px', right: '71px' },
                            React.createElement(Icon, { as: MdClose, _hover: { cursor: 'pointer' }, onClick: () => {
                                    var _a;
                                    if (item.id === ((_a = rstore.schemaStore.activeitem) === null || _a === void 0 ? void 0 : _a.id)) {
                                        rstore.schemaStore.setActiveItem(undefined);
                                        if (item.type === SchemaItemType.Choice) {
                                            rstore.schemaStore.setChoiceItems([]);
                                        }
                                        rstore.schemaStore.setActiveItemid("");
                                    }
                                    rstore.schemaStore.removeSchemaItem(item);
                                } })),
                        !adddragzone && React.createElement(Box, { w: '100%', h: '30px', key: item.id + '_dragtop' }),
                        adddragzone && React.createElement(Box, { key: item.id + '_dragtop', onDragOver: (e) => {
                                e.preventDefault();
                                if (rstore.schemaStore.dragging) {
                                    rstore.schemaStore.setDragZone(item.id + 'top');
                                }
                            }, onDragEnter: (e) => {
                                e.preventDefault();
                                if (rstore.schemaStore.dragging) {
                                    rstore.schemaStore.setDragZone(item.id + 'top');
                                }
                            }, onDragExit: (e) => {
                                e.preventDefault();
                                if (rstore.schemaStore.dragging && rstore.schemaStore.dragzone === item.id + 'top') {
                                    rstore.schemaStore.setDragZone('');
                                }
                            }, onDrop: () => {
                                if (!rstore.schemaStore.dragginitem) {
                                    return;
                                }
                                let min = 0;
                                if (index === 0) {
                                    min = 0;
                                }
                                else {
                                    min = items[index - 1].orderindex;
                                }
                                let max = item.orderindex;
                                rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                rstore.schemaStore.setDragZone('');
                                rstore.schemaStore.dragging = false;
                            }, w: '100%', h: '30px', 
                            // bg={rstore.schemaStore.dragzone === item.id + 'top' ? 'yellow' : 'transparent'}
                            className: rstore.schemaStore.dragzone === item.id + 'top' ? 'schema-drop-area' : '' }),
                        React.createElement(Flex, { bg: rstore.schemaStore.activeitemid === item.id ? '#829eb975' : 'transparent', _hover: { cursor: 'pointer' }, onClick: () => {
                                var _a;
                                rstore.schemaStore.setActiveItem(item);
                                if (item.type === SchemaItemType.Choice) {
                                    rstore.schemaStore.setChoiceItems((_a = item.items) !== null && _a !== void 0 ? _a : []);
                                }
                                rstore.schemaStore.setActiveItemid(item.id);
                            }, onDragOver: (e) => {
                                e.preventDefault();
                                if (rstore.schemaStore.dragging) {
                                    rstore.schemaStore.setDragZone(item.id + 'top');
                                }
                            }, onDragEnter: (e) => {
                                e.preventDefault();
                                if (rstore.schemaStore.dragging) {
                                    rstore.schemaStore.setDragZone(item.id + 'top');
                                }
                            }, onDragExit: (e) => {
                                e.preventDefault();
                                if (rstore.schemaStore.dragging && rstore.schemaStore.dragzone === item.id + 'top') {
                                    rstore.schemaStore.setDragZone('');
                                }
                            }, onDrop: () => {
                                if (!rstore.schemaStore.dragginitem) {
                                    return;
                                }
                                let min = 0;
                                let max = 0;
                                if (rstore.schemaStore.dragzone.indexOf("bottom") !== -1) {
                                    min = item.orderindex;
                                    max = index + 1;
                                }
                                else {
                                    min = 0;
                                    if (index === 0) {
                                        min = 0;
                                    }
                                    else {
                                        min = items[index - 1].orderindex;
                                    }
                                    max = item.orderindex;
                                }
                                rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                rstore.schemaStore.setDragZone('');
                                rstore.schemaStore.dragging = false;
                            }, draggable: true, onDragStart: () => {
                                rstore.schemaStore.dragging = true;
                                rstore.schemaStore.dragginitem = item;
                            }, onDragEnd: () => {
                                if (rstore.schemaStore.dragginitem && rstore.schemaStore.dragzone) {
                                    let min = 0;
                                    let max = 0;
                                    if (rstore.schemaStore.dragzone.indexOf("bottom") !== -1) {
                                        min = item.orderindex;
                                        max = index + 1;
                                    }
                                    else {
                                        min = 0;
                                        if (index === 0) {
                                            min = 0;
                                        }
                                        else {
                                            min = items[index - 1].orderindex;
                                        }
                                        max = item.orderindex;
                                    }
                                    rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                    rstore.schemaStore.setDragZone('');
                                    rstore.schemaStore.dragging = false;
                                }
                                rstore.schemaStore.dragging = false;
                                rstore.schemaStore.setDragZone('');
                            }, ml: '15px', justify: 'center', align: 'center', height: '70px', borderRadius: '10px', borderWidth: '1px', borderColor: 'lightgray', key: item.id, w: '80%' },
                            React.createElement(Box, { w: '80%' },
                                React.createElement(Flex, { mt: '10px', justify: 'center', align: 'center', w: '100%' },
                                    icon !== undefined && icon,
                                    React.createElement(Text, { ml: '5px' }, item.name)),
                                React.createElement(Flex, { mt: '10px', justify: 'center', align: 'center', w: '100%' },
                                    React.createElement(Text, null, label))),
                            React.createElement(Flex, { w: '15%', align: 'center', justify: 'center', h: '100%' },
                                React.createElement(Icon, { as: GrDrag, _hover: { cursor: 'grab' } }))),
                        adddragzone && index === items.length - 1 &&
                            React.createElement(Box, { onDragOver: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging) {
                                        rstore.schemaStore.setDragZone(item.id + 'bottom');
                                    }
                                }, onDragExit: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging && rstore.schemaStore.dragzone === item.id + 'bottom') {
                                        rstore.schemaStore.setDragZone('');
                                    }
                                }, onDragEnter: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging) {
                                        rstore.schemaStore.setDragZone(item.id + 'bottom');
                                    }
                                }, onDrop: () => {
                                    if (!rstore.schemaStore.dragginitem) {
                                        return;
                                    }
                                    let min = item.orderindex;
                                    let max = index + 1;
                                    rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                    rstore.schemaStore.setDragZone('');
                                    rstore.schemaStore.dragging = false;
                                }, w: '100%', h: '30px', 
                                // bg={rstore.schemaStore.dragzone === item.id + 'bottom' ? 'green' : 'transparent'}
                                className: rstore.schemaStore.dragzone === item.id + 'bottom' ? 'schema-drop-area' : '' }));
                }))));
    }
    renderDetailsPanel() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const rstore = this.context;
        if (rstore.schemaStore.activeitem === undefined) {
            return React.createElement(Box, null);
        }
        return React.createElement(Box, { padding: '10px', borderWidth: '1px', borderEndColor: AppColor.TableBorderColor },
            React.createElement(Box, { padding: '10px' },
                React.createElement(Flex, { h: '20px' },
                    React.createElement(Flex, { width: '90%' },
                        React.createElement(Text, { fontWeight: 'bold', fontSize: '12px' }, "Details")),
                    React.createElement(Flex, { justify: 'flex-end' },
                        React.createElement(Icon, { w: '20px', h: '20px', onClick: () => rstore.schemaStore.setActiveItem(undefined), color: AppColor.DeleteIconColor, as: MdClose }))),
                rstore.schemaStore.activeitemid && React.createElement(Box, { w: '100%', maxH: window.innerHeight - 300 + "px", overflow: 'auto', paddingLeft: '5px' },
                    rstore.schemaStore.activeitem &&
                        ((_a = rstore.schemaStore.activeitem) === null || _a === void 0 ? void 0 : _a.type) === SchemaItemType.Text &&
                        React.createElement(TextItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_b = rstore.schemaStore.activeitem) === null || _b === void 0 ? void 0 : _b.type) === SchemaItemType.ID &&
                        React.createElement(IDItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_c = rstore.schemaStore.activeitem) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number &&
                        React.createElement(NumberItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_d = rstore.schemaStore.activeitem) === null || _d === void 0 ? void 0 : _d.type) === SchemaItemType.Color &&
                        React.createElement(ColorItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_e = rstore.schemaStore.activeitem) === null || _e === void 0 ? void 0 : _e.type) === SchemaItemType.Boolean &&
                        React.createElement(CheckboxItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_f = rstore.schemaStore.activeitem) === null || _f === void 0 ? void 0 : _f.type) === SchemaItemType.Choice &&
                        React.createElement(ChoiceItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem && rstore.schemaStore.activeitem.type === SchemaItemType.Date &&
                        React.createElement(DateItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_g = rstore.schemaStore.activeitem) === null || _g === void 0 ? void 0 : _g.type) === SchemaItemType.FormInput &&
                        React.createElement(FormInputDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_h = rstore.schemaStore.activeitem) === null || _h === void 0 ? void 0 : _h.type) === SchemaItemType.URL &&
                        React.createElement(URLItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_j = rstore.schemaStore.activeitem) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.UserChoice &&
                        React.createElement(UserItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_k = rstore.schemaStore.activeitem) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Objects &&
                        React.createElement(ObjectItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem &&
                        ((_l = rstore.schemaStore.activeitem) === null || _l === void 0 ? void 0 : _l.type) === SchemaItemType.List &&
                        React.createElement(ListItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                    rstore.schemaStore.activeitem && ((_m = rstore.schemaStore.activeitem) === null || _m === void 0 ? void 0 : _m.type) === SchemaItemType.Remote &&
                        React.createElement(RemoteItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }))));
    }
    renderTypesPanel() {
        const rstore = this.context;
        if (!rstore.schemaStore.showtypesmenu) {
            return React.createElement(Box, null);
        }
        return React.createElement(Box, { h: window.innerHeight - 150 + "px", padding: '10px', borderWidth: '1px', borderEndColor: AppColor.TableBorderColor, width: '200px' },
            React.createElement(Flex, { h: '20px' },
                React.createElement(Flex, { width: '90%' },
                    React.createElement(Text, { fontWeight: 'bold', fontSize: '12px' }, "Types")),
                React.createElement(Flex, { justify: 'flex-end' },
                    React.createElement(Icon, { w: '20px', h: '20px', onClick: () => rstore.schemaStore.setShowTypesMenu(false), color: AppColor.DeleteIconColor, as: MdClose }))),
            React.createElement(Box, { maxH: window.innerHeight - 180 + "px", padding: '20px', overflow: 'auto' },
                React.createElement(Flex, { borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Text) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: BiText }),
                        React.createElement(Text, null, "Text")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Number) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: AiOutlineNumber }),
                        React.createElement(Text, null, "Number")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.ID) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: FaIdCard }),
                        React.createElement(Text, null, "ID")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Boolean) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: MdCheckBox }),
                        React.createElement(Text, null, "Checkbox")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.Color) },
                        React.createElement(Icon, { as: MdColorize }),
                        React.createElement(Text, null, "Color")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.UserChoice) },
                        React.createElement(Icon, { as: FaUser }),
                        React.createElement(Text, null, "User")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.Objects) },
                        React.createElement(Icon, { as: HiDocument }),
                        React.createElement(Text, null, "Object")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Choice) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: MdList }),
                        React.createElement(Text, null, "Choice")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Date) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: FaCalendar }),
                        React.createElement(Text, null, "Date")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.FormInput) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: MdEdit }),
                        React.createElement(Text, null, "Form Input")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.URL) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: MdLink }),
                        React.createElement(Text, null, "Link")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.List) },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                        React.createElement(Icon, { as: RiTableLine }),
                        React.createElement(Text, null, "List")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus }))),
                React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                    React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.Remote) },
                        React.createElement(Icon, { as: GrConnect }),
                        React.createElement(Text, null, "Remote Object")),
                    React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                        React.createElement(Icon, { as: FiPlus })))));
    }
    dialogBody() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const rstore = this.context;
        const items = rstore.schemaStore.getSchemaItems();
        if (testIsMobile()) {
            return this.dialogBodyMobile();
        }
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(Flex, { w: '100%', align: 'center' },
                React.createElement(FormControl, { w: '40%' },
                    React.createElement(FormLabel, { htmlFor: 'tabname' }, "Name"),
                    React.createElement(Input, { value: rstore.schemaStore.name, onChange: (e) => rstore.schemaStore.setName(e.currentTarget.value), id: 'tabname' })),
                React.createElement(Viewers, null),
                React.createElement(Flex, { ml: '5px', w: '100%', justify: 'center', align: 'center' }, rstore.schemaStore.saving && React.createElement(ScaleLoader, { color: 'green' }))),
            rstore.mainSchemaStore.schemas.size > 0 && React.createElement(Flex, { w: '100%', align: 'center' },
                React.createElement(Observer, null, () => React.createElement(Checkbox, { disabled: rstore.schemaStore.editmode, checked: rstore.schemaStore.derived, defaultChecked: rstore.schemaStore.derived, onChange: (e) => rstore.schemaStore.setDervied(e.currentTarget.checked) }, "Derived Schema")),
                rstore.schemaStore.derived && React.createElement(Select, { ml: '20px', disabled: rstore.schemaStore.editmode, width: '250px', value: rstore.schemaStore.derviedschema, placeholder: 'Select schema', onChange: (e) => {
                        rstore.schemaStore.dervivedsch = rstore.mainSchemaStore.schemas.get(e.currentTarget.value);
                        if (!rstore.schemaStore.dervivedsch) {
                            return;
                        }
                        rstore.schemaStore.setDervicedSchema(e.currentTarget.value);
                    } }, Array.from(rstore.mainSchemaStore.schemas.values()).filter((sh) => sh.parentschema === undefined)
                    .slice()
                    .map((tab) => React.createElement("option", { key: tab.id, value: tab.id }, tab.name)))),
            React.createElement(HStack, { w: '100%', h: '80%', align: 'flex-start' },
                React.createElement(Box, { w: '20%' },
                    React.createElement(Flex, { h: '40px', justify: 'center', w: '100%' },
                        React.createElement(Text, { fontWeight: 'bold' }, "Types")),
                    React.createElement(Box, { maxH: '80%', padding: '20px', overflow: 'auto' },
                        React.createElement(Flex, { borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Text) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: BiText }),
                                React.createElement(Text, null, "Text")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Number) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: AiOutlineNumber }),
                                React.createElement(Text, null, "Number")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.ID) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: FaIdCard }),
                                React.createElement(Text, null, "ID")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Boolean) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: MdCheckBox }),
                                React.createElement(Text, null, "Checkbox")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.Color) },
                                React.createElement(Icon, { as: MdColorize }),
                                React.createElement(Text, null, "Color")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.UserChoice) },
                                React.createElement(Icon, { as: FaUser }),
                                React.createElement(Text, null, "User")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.Objects) },
                                React.createElement(Icon, { as: HiDocument }),
                                React.createElement(Text, null, "Object")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Choice) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: MdList }),
                                React.createElement(Text, null, "Choice")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.Date) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: FaCalendar }),
                                React.createElement(Text, null, "Date")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.FormInput) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: MdEdit }),
                                React.createElement(Text, null, "Form Input")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.URL) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: MdLink }),
                                React.createElement(Text, null, "Link")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center', onClick: () => this.addType(SchemaItemType.List) },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center' },
                                React.createElement(Icon, { as: RiTableLine }),
                                React.createElement(Text, null, "List")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))),
                        React.createElement(Flex, { mt: '10px', borderRadius: '10px', className: 'schema-item', borderWidth: '1px', borderColor: 'lightgray', justify: 'center', w: '100%', align: 'center' },
                            React.createElement(Flex, { w: '80%', justify: 'center', align: 'center', onClick: () => this.addType(SchemaItemType.Remote) },
                                React.createElement(Icon, { as: GrConnect }),
                                React.createElement(Text, null, "Remote Object")),
                            React.createElement(Flex, { _hover: { cursor: 'pointer' }, w: '20%', justify: 'flex-end' },
                                React.createElement(Icon, { as: FiPlus }))))),
                React.createElement(Observer, null, () => React.createElement(Box, { w: '40%', ml: '5px', maxH: '600px', overflow: 'auto' },
                    React.createElement(Flex, { h: '40px', justify: 'center', w: '100%' },
                        React.createElement(Text, { fontWeight: 'bold' }, "Columns")),
                    items.length === 0 && React.createElement(Box, { key: 'no_columns', onDragOver: () => {
                        }, h: '100px', w: '100%' }),
                    items.length > 0 && items.map((item, index) => {
                        let label = "";
                        let icon = undefined;
                        if (item.type === SchemaItemType.Text) {
                            label = "Text";
                            icon = React.createElement(Icon, { as: BiText });
                        }
                        else if (item.type === SchemaItemType.Number) {
                            label = "Number";
                            icon = React.createElement(Icon, { as: AiOutlineNumber });
                        }
                        else if (item.type === SchemaItemType.ID) {
                            label = "ID";
                            icon = React.createElement(Icon, { as: FaIdCard });
                        }
                        else if (item.type === SchemaItemType.Boolean) {
                            label = "Checkbox";
                            icon = React.createElement(Icon, { as: MdCheckBox });
                        }
                        else if (item.type === SchemaItemType.Color) {
                            label = "Color";
                            icon = React.createElement(Icon, { as: MdColorize });
                        }
                        else if (item.type === SchemaItemType.Choice) {
                            label = "Choice";
                            icon = React.createElement(Icon, { as: MdList });
                        }
                        else if (item.type === SchemaItemType.Date) {
                            label = "Date";
                            icon = React.createElement(Icon, { as: FaCalendar });
                        }
                        else if (item.type === SchemaItemType.FormInput) {
                            label = "Form Input";
                            icon = React.createElement(Icon, { as: MdEdit });
                        }
                        else if (item.type === SchemaItemType.URL) {
                            label = "Link";
                            icon = React.createElement(Icon, { as: MdLink });
                        }
                        else if (item.type === SchemaItemType.UserChoice) {
                            label = "User";
                            icon = React.createElement(Icon, { as: FaUser });
                        }
                        else if (item.type === SchemaItemType.Objects) {
                            label = "Objects";
                            icon = React.createElement(Icon, { as: HiDocument });
                        }
                        else if (item.type === SchemaItemType.List) {
                            label = "List";
                            icon = React.createElement(Icon, { as: RiTableLine });
                        }
                        else if (item.type === SchemaItemType.Remote) {
                            label = "Remote Item";
                            icon = React.createElement(Icon, { as: GrConnect });
                        }
                        const adddragzone = items.length > 1;
                        return React.createElement(Box, { pos: 'relative', minH: '100px', key: item.id + '_mainitem', w: '100%' },
                            React.createElement(Flex, { pos: 'absolute', top: '32px', right: '71px' },
                                React.createElement(Icon, { as: MdClose, _hover: { cursor: 'pointer' }, onClick: () => {
                                        var _a;
                                        if (item.id === ((_a = rstore.schemaStore.activeitem) === null || _a === void 0 ? void 0 : _a.id)) {
                                            rstore.schemaStore.setActiveItem(undefined);
                                            if (item.type === SchemaItemType.Choice) {
                                                rstore.schemaStore.setChoiceItems([]);
                                            }
                                            rstore.schemaStore.setActiveItemid("");
                                        }
                                        rstore.schemaStore.removeSchemaItem(item);
                                    } })),
                            !adddragzone && React.createElement(Box, { w: '100%', h: '30px', key: item.id + '_dragtop' }),
                            adddragzone && React.createElement(Box, { key: item.id + '_dragtop', onDragOver: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging) {
                                        rstore.schemaStore.setDragZone(item.id + 'top');
                                    }
                                }, onDragEnter: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging) {
                                        rstore.schemaStore.setDragZone(item.id + 'top');
                                    }
                                }, onDragExit: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging && rstore.schemaStore.dragzone === item.id + 'top') {
                                        rstore.schemaStore.setDragZone('');
                                    }
                                }, onDrop: () => {
                                    if (!rstore.schemaStore.dragginitem) {
                                        return;
                                    }
                                    let min = 0;
                                    if (index === 0) {
                                        min = 0;
                                    }
                                    else {
                                        min = items[index - 1].orderindex;
                                    }
                                    let max = item.orderindex;
                                    rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                    rstore.schemaStore.setDragZone('');
                                    rstore.schemaStore.dragging = false;
                                }, w: '100%', h: '30px', 
                                // bg={rstore.schemaStore.dragzone === item.id + 'top' ? 'yellow' : 'transparent'}
                                className: rstore.schemaStore.dragzone === item.id + 'top' ? 'schema-drop-area' : '' }),
                            React.createElement(Flex, { bg: rstore.schemaStore.activeitemid === item.id ? '#829eb975' : 'transparent', _hover: { cursor: 'pointer' }, onClick: () => {
                                    var _a;
                                    rstore.schemaStore.setActiveItem(item);
                                    if (item.type === SchemaItemType.Choice) {
                                        rstore.schemaStore.setChoiceItems((_a = item.items) !== null && _a !== void 0 ? _a : []);
                                    }
                                    rstore.schemaStore.setActiveItemid(item.id);
                                }, onDragOver: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging) {
                                        rstore.schemaStore.setDragZone(item.id + 'top');
                                    }
                                }, onDragEnter: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging) {
                                        rstore.schemaStore.setDragZone(item.id + 'top');
                                    }
                                }, onDragExit: (e) => {
                                    e.preventDefault();
                                    if (rstore.schemaStore.dragging && rstore.schemaStore.dragzone === item.id + 'top') {
                                        rstore.schemaStore.setDragZone('');
                                    }
                                }, onDrop: () => {
                                    if (!rstore.schemaStore.dragginitem) {
                                        return;
                                    }
                                    let min = 0;
                                    let max = 0;
                                    if (rstore.schemaStore.dragzone.indexOf("bottom") !== -1) {
                                        min = item.orderindex;
                                        max = index + 1;
                                    }
                                    else {
                                        min = 0;
                                        if (index === 0) {
                                            min = 0;
                                        }
                                        else {
                                            min = items[index - 1].orderindex;
                                        }
                                        max = item.orderindex;
                                    }
                                    rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                    rstore.schemaStore.setDragZone('');
                                    rstore.schemaStore.dragging = false;
                                }, draggable: true, onDragStart: () => {
                                    rstore.schemaStore.dragging = true;
                                    rstore.schemaStore.dragginitem = item;
                                }, onDragEnd: () => {
                                    if (rstore.schemaStore.dragginitem && rstore.schemaStore.dragzone) {
                                        let min = 0;
                                        let max = 0;
                                        if (rstore.schemaStore.dragzone.indexOf("bottom") !== -1) {
                                            min = item.orderindex;
                                            max = index + 1;
                                        }
                                        else {
                                            min = 0;
                                            if (index === 0) {
                                                min = 0;
                                            }
                                            else {
                                                min = items[index - 1].orderindex;
                                            }
                                            max = item.orderindex;
                                        }
                                        rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                        rstore.schemaStore.setDragZone('');
                                        rstore.schemaStore.dragging = false;
                                    }
                                    rstore.schemaStore.dragging = false;
                                    rstore.schemaStore.setDragZone('');
                                }, ml: '15px', justify: 'center', align: 'center', height: '70px', borderRadius: '10px', borderWidth: '1px', borderColor: 'lightgray', key: item.id, w: '80%' },
                                React.createElement(Box, { w: '80%' },
                                    React.createElement(Flex, { mt: '10px', justify: 'center', align: 'center', w: '100%' },
                                        icon !== undefined && icon,
                                        React.createElement(Text, { ml: '5px' }, item.name)),
                                    React.createElement(Flex, { mt: '10px', justify: 'center', align: 'center', w: '100%' },
                                        React.createElement(Text, null, label))),
                                React.createElement(Flex, { w: '15%', align: 'center', justify: 'center', h: '100%' },
                                    React.createElement(Icon, { as: GrDrag, _hover: { cursor: 'grab' } }))),
                            adddragzone && index === items.length - 1 &&
                                React.createElement(Box, { onDragOver: (e) => {
                                        e.preventDefault();
                                        if (rstore.schemaStore.dragging) {
                                            rstore.schemaStore.setDragZone(item.id + 'bottom');
                                        }
                                    }, onDragExit: (e) => {
                                        e.preventDefault();
                                        if (rstore.schemaStore.dragging && rstore.schemaStore.dragzone === item.id + 'bottom') {
                                            rstore.schemaStore.setDragZone('');
                                        }
                                    }, onDragEnter: (e) => {
                                        e.preventDefault();
                                        if (rstore.schemaStore.dragging) {
                                            rstore.schemaStore.setDragZone(item.id + 'bottom');
                                        }
                                    }, onDrop: () => {
                                        if (!rstore.schemaStore.dragginitem) {
                                            return;
                                        }
                                        let min = item.orderindex;
                                        let max = index + 1;
                                        rstore.schemaStore.moveItemBetween(rstore.schemaStore.dragginitem, min, max);
                                        rstore.schemaStore.setDragZone('');
                                        rstore.schemaStore.dragging = false;
                                    }, w: '100%', h: '30px', 
                                    // bg={rstore.schemaStore.dragzone === item.id + 'bottom' ? 'green' : 'transparent'}
                                    className: rstore.schemaStore.dragzone === item.id + 'bottom' ? 'schema-drop-area' : '' }));
                    }))),
                React.createElement(Box, { w: '40%', padding: '10px' },
                    React.createElement(Flex, { h: '40px', justify: 'center', w: '100%' },
                        React.createElement(Text, { fontWeight: 'bold' }, "Details")),
                    rstore.schemaStore.activeitemid && React.createElement(Box, { w: '100%', maxH: '500px', overflow: 'auto', paddingLeft: '5px' },
                        rstore.schemaStore.activeitem &&
                            ((_a = rstore.schemaStore.activeitem) === null || _a === void 0 ? void 0 : _a.type) === SchemaItemType.Text &&
                            React.createElement(TextItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_b = rstore.schemaStore.activeitem) === null || _b === void 0 ? void 0 : _b.type) === SchemaItemType.ID &&
                            React.createElement(IDItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_c = rstore.schemaStore.activeitem) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number &&
                            React.createElement(NumberItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_d = rstore.schemaStore.activeitem) === null || _d === void 0 ? void 0 : _d.type) === SchemaItemType.Color &&
                            React.createElement(ColorItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_e = rstore.schemaStore.activeitem) === null || _e === void 0 ? void 0 : _e.type) === SchemaItemType.Boolean &&
                            React.createElement(CheckboxItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_f = rstore.schemaStore.activeitem) === null || _f === void 0 ? void 0 : _f.type) === SchemaItemType.Choice &&
                            React.createElement(ChoiceItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem && rstore.schemaStore.activeitem.type === SchemaItemType.Date &&
                            React.createElement(DateItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_g = rstore.schemaStore.activeitem) === null || _g === void 0 ? void 0 : _g.type) === SchemaItemType.FormInput &&
                            React.createElement(FormInputDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_h = rstore.schemaStore.activeitem) === null || _h === void 0 ? void 0 : _h.type) === SchemaItemType.URL &&
                            React.createElement(URLItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_j = rstore.schemaStore.activeitem) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.UserChoice &&
                            React.createElement(UserItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_k = rstore.schemaStore.activeitem) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Objects &&
                            React.createElement(ObjectItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem &&
                            ((_l = rstore.schemaStore.activeitem) === null || _l === void 0 ? void 0 : _l.type) === SchemaItemType.List &&
                            React.createElement(ListItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
                        rstore.schemaStore.activeitem && ((_m = rstore.schemaStore.activeitem) === null || _m === void 0 ? void 0 : _m.type) === SchemaItemType.Remote &&
                            React.createElement(RemoteItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem })))));
    }
    render() {
        const rstore = this.context;
        return React.createElement(React.Fragment, null,
            React.createElement(SelectMemberDialog, { state: rstore.schemaStore.smstate }),
            React.createElement(BaseDialog, { body: this.dialogBody(), state: rstore.schemaStore.dialog }));
    }
};
SchemaDialog.contextType = StoreContext;
SchemaDialog = __decorate([
    observer
], SchemaDialog);
export { SchemaDialog };
let ListItemDetail = class ListItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        const rstore = this.context;
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Add Item"),
                React.createElement(Flex, null,
                    React.createElement(Icon, { _hover: { cursor: 'pointer' }, as: FaPlus, onClick: (e) => {
                            var _a, _b;
                            const item = {
                                id: LetrwingCrypto.getUUID() + '',
                                name: 'Item ' + ((_b = (_a = this.props.item.items) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0),
                                orderindex: -1,
                                required: false,
                                type: rstore.schemaStore.subitemtype
                            };
                            rstore.schemaStore.addItemToSubItem(item, this.props.item);
                        } }),
                    React.createElement(Select, { size: 'sm', ml: '20px', width: '250px', placeholder: 'Select Type', defaultValue: SchemaItemType.FormInput, onChange: (e) => {
                            if (e.currentTarget.value == SchemaItemType.Boolean.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Boolean);
                            }
                            else if (e.currentTarget.value == SchemaItemType.FormInput.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.FormInput);
                            }
                            else if (e.currentTarget.value == SchemaItemType.Text.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Text);
                            }
                            else if (e.currentTarget.value == SchemaItemType.Number.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Number);
                            }
                            else if (e.currentTarget.value == SchemaItemType.Date.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Date);
                            }
                            else if (e.currentTarget.value == SchemaItemType.Choice.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Choice);
                            }
                            else if (e.currentTarget.value == SchemaItemType.UserChoice.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.UserChoice);
                            }
                            else if (e.currentTarget.value == SchemaItemType.Objects.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Objects);
                            }
                            else if (e.currentTarget.value === SchemaItemType.Remote.toString()) {
                                rstore.schemaStore.setSubItemType(SchemaItemType.Remote);
                            }
                            const sel = e.currentTarget.value;
                        } },
                        React.createElement("option", { key: SchemaItemType.Boolean, value: SchemaItemType.Boolean }, 'Checkbox'),
                        React.createElement("option", { key: SchemaItemType.FormInput, value: SchemaItemType.FormInput }, 'Form Input'),
                        React.createElement("option", { key: SchemaItemType.Text, value: SchemaItemType.Text }, 'Text'),
                        React.createElement("option", { key: SchemaItemType.Number, value: SchemaItemType.Number }, 'Number'),
                        React.createElement("option", { key: SchemaItemType.Date, value: SchemaItemType.Date }, 'Date'),
                        React.createElement("option", { key: SchemaItemType.Choice, value: SchemaItemType.Choice }, 'Choice'),
                        React.createElement("option", { key: SchemaItemType.UserChoice, value: SchemaItemType.UserChoice }, 'User Choice'),
                        React.createElement("option", { key: SchemaItemType.Objects, value: SchemaItemType.Objects }, 'Object'),
                        React.createElement("option", { key: SchemaItemType.Remote, value: SchemaItemType.Remote }, 'Remote Object')))),
            React.createElement(FormControl, null,
                React.createElement(SubListItems, { item: this.props.item })));
    }
};
ListItemDetail.contextType = StoreContext;
ListItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ListItemDetail);
let SubListItems = class SubListItems extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        const rstore = this.context;
        if (this.props.item.items === undefined || this.props.item.items.length === 0) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Flex, { width: '100%' },
            React.createElement(Box, { maxHeight: '200px', width: '150px', overflow: 'auto' }, this.props.item.items.map((litem, index) => {
                let item = litem.item;
                let label = "";
                let icon = undefined;
                if (item.type === SchemaItemType.Text) {
                    label = "Text";
                    icon = React.createElement(Icon, { as: BiText });
                }
                else if (item.type === SchemaItemType.Number) {
                    label = "Number";
                    icon = React.createElement(Icon, { as: AiOutlineNumber });
                }
                else if (item.type === SchemaItemType.ID) {
                    label = "ID";
                    icon = React.createElement(Icon, { as: FaIdCard });
                }
                else if (item.type === SchemaItemType.Boolean) {
                    label = "Checkbox";
                    icon = React.createElement(Icon, { as: MdCheckBox });
                }
                else if (item.type === SchemaItemType.Color) {
                    label = "Color";
                    icon = React.createElement(Icon, { as: MdColorize });
                }
                else if (item.type === SchemaItemType.Choice) {
                    label = "Choice";
                    icon = React.createElement(Icon, { as: MdList });
                }
                else if (item.type === SchemaItemType.Date) {
                    label = "Date";
                    icon = React.createElement(Icon, { as: FaCalendar });
                }
                else if (item.type === SchemaItemType.FormInput) {
                    label = "Form Input";
                    icon = React.createElement(Icon, { as: GrFormEdit });
                }
                else if (item.type === SchemaItemType.URL) {
                    label = "Link";
                    icon = React.createElement(Icon, { as: MdLink });
                }
                else if (item.type === SchemaItemType.UserChoice) {
                    label = "User";
                    icon = React.createElement(Icon, { as: FaUser });
                }
                else if (item.type === SchemaItemType.Objects) {
                    label = "Objects";
                    icon = React.createElement(Icon, { as: HiDocument });
                }
                else if (item.type === SchemaItemType.List) {
                    label = "List";
                    icon = React.createElement(Icon, { as: RiTableLine });
                }
                else if (item.type === SchemaItemType.Remote) {
                    label = "Remote Object";
                    icon = React.createElement(Icon, { as: GrConnect });
                }
                return React.createElement(Box, { _hover: { cursor: 'pointer' }, onClick: (e) => {
                        var _a;
                        if (litem.item.type === SchemaItemType.Choice) {
                            rstore.schemaStore.setChoiceItems((_a = item.items) !== null && _a !== void 0 ? _a : []);
                        }
                        rstore.schemaStore.addSubItemId(litem.id);
                    }, backgroundColor: rstore.schemaStore.selectedsubitemid === litem.id ? '#829eb975' : 'transparent', borderRadius: '10px', borderWidth: '1px', borderColor: 'lightgray', width: '100px', margin: '10px', pos: 'relative', minH: '75px', key: item.id + '_mainitem' },
                    React.createElement(Flex, { pos: 'absolute', top: '14px', right: '2px' },
                        React.createElement(Icon, { as: MdClose, _hover: { cursor: 'pointer' }, onClick: () => {
                                rstore.schemaStore.removeItemFromSubList(index, this.props.item);
                            } })),
                    React.createElement(Box, { w: '80%' },
                        React.createElement(Flex, { mt: '10px', justify: 'center', align: 'center', w: '100%' },
                            icon !== undefined && icon,
                            React.createElement(Text, { ml: '5px' }, item.name)),
                        React.createElement(Flex, { mt: '10px', justify: 'center', align: 'center', w: '100%' },
                            React.createElement(Text, null, label))));
            })),
            React.createElement(SelectedSubItem, { item: this.props.item }));
    }
};
SubListItems.contextType = StoreContext;
SubListItems = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], SubListItems);
let SelectedSubItem = class SelectedSubItem extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        var _a;
        const rstore = this.context;
        if (!rstore.schemaStore.selectedsubitemid) {
            return React.createElement(React.Fragment, null);
        }
        const sitem = ((_a = this.props.item.items) !== null && _a !== void 0 ? _a : []).filter((it) => it.id === rstore.schemaStore.selectedsubitemid);
        if (sitem.length === 0) {
            return React.createElement(React.Fragment, null);
        }
        const sit = sitem[0];
        return React.createElement(Box, { padding: '10px' }, sit && React.createElement(Box, { w: '100%', maxH: '200px', overflow: 'auto', paddingLeft: '5px' },
            sit &&
                sit.item.type === SchemaItemType.Text &&
                React.createElement(TextItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.ID &&
                React.createElement(IDItemDetail, { key: rstore.schemaStore.activeitemid, item: rstore.schemaStore.activeitem }),
            sit &&
                sit.item.type === SchemaItemType.Number &&
                React.createElement(NumberItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.Color &&
                React.createElement(ColorItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.Boolean &&
                React.createElement(CheckboxItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.Choice &&
                React.createElement(ChoiceItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.Date &&
                React.createElement(DateItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.FormInput &&
                React.createElement(FormInputDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.URL &&
                React.createElement(URLItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.UserChoice &&
                React.createElement(UserItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.Objects &&
                React.createElement(ObjectItemDetail, { key: sit.item.id, item: sit.item }),
            sit &&
                sit.item.type === SchemaItemType.Remote &&
                React.createElement(RemoteItemDetail, { key: sit.item.id, item: sit.item })));
    }
};
SelectedSubItem.contextType = StoreContext;
SelectedSubItem = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], SelectedSubItem);
let Viewers = class Viewers extends React.Component {
    render() {
        const rstore = this.context;
        return React.createElement(Flex, null,
            React.createElement(Flex, { alignItems: 'center' },
                React.createElement(Box, { ml: '20px' },
                    React.createElement(Observer, null, () => React.createElement(Checkbox, { size: testIsMobile() ? 'sm' : 'md', defaultChecked: rstore.schemaStore.vieweabletoeveryone, onChange: (e) => rstore.schemaStore.setViewableToEveryone(e.currentTarget.checked) }, "Visible to Everyone"))),
                React.createElement(Button, { ml: '10px', size: testIsMobile() ? 'sm' : 'md', disabled: rstore.schemaStore.vieweabletoeveryone, onClick: () => {
                        const dh = rstore.datasheetStore.getDatasheet(rstore.datasheetStore.activedid);
                        if (dh) {
                            let mds = rstore.projectStore.memberDetail;
                            let mlink = rstore.projectStore.letrlinks.map((link) => (Object.assign(Object.assign({}, link), { id: "freesoul-" + link.id })));
                            if (dh.viewers.indexOf(ALLViewer) === -1) {
                                mds = mds.filter((md) => dh.viewers.indexOf(md.id) !== -1);
                                mlink = mlink.filter((ml) => dh.viewers.indexOf(ml.id) !== -1);
                            }
                            rstore.schemaStore.smstate.setLetrMembers(mds);
                            rstore.schemaStore.smstate.setLetrLinks(mlink);
                        }
                        rstore.schemaStore.smstate.basestate.setOpen(true);
                    }, variant: 'solid' }, "Viewers"),
                rstore.schemaStore.smstate.selectedcontacts.size > 0 && React.createElement(Button, { onClick: () => {
                        const dh = rstore.datasheetStore.getDatasheet(rstore.datasheetStore.activedid);
                        if (dh) {
                            let mds = rstore.letrAndTagStore.actveltermembers;
                            let mlink = rstore.projectStore.letrlinks.map((link) => (Object.assign(Object.assign({}, link), { id: "freesoul-" + link.id })));
                            if (dh.viewers.indexOf(ALLViewer) === -1) {
                                mds = mds.filter((md) => dh.viewers.indexOf(md.id) !== -1);
                                mlink = mlink.filter((ml) => dh.viewers.indexOf(ml.id) !== -1);
                            }
                            rstore.schemaStore.smstate.setLetrMembers(mds);
                            rstore.schemaStore.smstate.setLetrLinks(mlink);
                        }
                        rstore.schemaStore.smstate.basestate.setOpen(true);
                    }, style: { marginLeft: 20 }, variant: 'solid' }, rstore.schemaStore.smstate.selectedcontacts.size)));
    }
};
Viewers.contextType = StoreContext;
Viewers = __decorate([
    observer
], Viewers);
export { Viewers };
let ChoiceItemDetail = class ChoiceItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        const rstore = this.context;
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Multi Select"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.multiselect, onChange: (e) => this.props.item.multiselect = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Enable disable multi select")),
            React.createElement(Box, { mt: '5px' },
                React.createElement(Button, { size: 'sm', variant: 'unstyled', onClick: () => {
                        const ncit = {
                            id: LetrwingCrypto.getUUID() + '',
                            name: '',
                            type: ChoiceType.Text
                        };
                        rstore.schemaStore.addChoiceItem(ncit);
                        if (!this.props.item.items) {
                            this.props.item.items = [];
                        }
                        this.props.item.items.push(ncit);
                    } }, "Add Field"),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Default Value"),
                    React.createElement(Observer, null, () => React.createElement(Select, { placeholder: 'Select Default', value: this.props.item.defaultvalue, onChange: (e) => {
                            this.props.item.defaultvalue = e.currentTarget.value;
                        } }, this.props.item.items !== undefined
                        && this.props.item.items.map(item => React.createElement("option", { value: item.id, key: item.id }, item.name)))),
                    React.createElement(FormHelperText, null, "Default value for this field")),
                React.createElement(Box, { mt: '5px', maxH: '200px', overflow: 'auto' }, rstore.schemaStore.choiceitems.map((item, index) => {
                    return React.createElement(Flex, { w: '100%', h: '70px', key: item.id },
                        !this.props.item.multiselect && React.createElement(ColorInput, { id: 'color_' + item.id, defaultvalue: '', onChange: (e) => {
                                console.log(e);
                            } }),
                        React.createElement(Input, { defaultValue: item.name, onChange: (e) => {
                                if (e.currentTarget.value.trim()) {
                                    item.name = e.currentTarget.value.trim();
                                    this.props.item.items[index].name = e.currentTarget.value.trim();
                                }
                            } }),
                        React.createElement(Icon, { as: MdDelete, onClick: () => {
                                const itemin = index;
                                if (itemin > -1) {
                                    this.props.item.items.splice(itemin, 1);
                                    rstore.schemaStore.removeChoiceItem(item);
                                }
                            } }));
                }))));
    }
};
ChoiceItemDetail.contextType = StoreContext;
ChoiceItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ChoiceItemDetail);
let DateItemDetail = class DateItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Disable Date"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.excludedate, onChange: (e) => this.props.item.excludedate = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Disable date picker for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Enable Time"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.inlcudetime, onChange: (e) => this.props.item.inlcudetime = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Enable time for each date")));
    }
};
DateItemDetail.contextType = StoreContext;
DateItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DateItemDetail);
let CheckboxItemDetail = class CheckboxItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Default Value"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.defaultvalue === 'true' ? true : false, onChange: (e) => this.props.item.defaultvalue = e.currentTarget.checked ? 'true' : 'false' }),
                React.createElement(FormHelperText, null, "Default value for this field")));
    }
};
CheckboxItemDetail.contextType = StoreContext;
CheckboxItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], CheckboxItemDetail);
let ImageItemDetail = class ImageItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")));
    }
};
ImageItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ImageItemDetail);
let ColorItemDetail = class ColorItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")));
    }
};
ColorItemDetail.contextType = StoreContext;
ColorItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ColorItemDetail);
let FormInputDetail = class FormInputDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        var _a;
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Secret"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.enablesecret, onChange: (e) => this.props.item.enablesecret = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "If enabled field will be treated as password")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Default Value"),
                React.createElement(Input, { defaultValue: (_a = this.props.item.defaultvalue) !== null && _a !== void 0 ? _a : '', onChange: (e) => {
                        this.props.item.defaultvalue = e.currentTarget.value.trim();
                    } }),
                React.createElement(FormHelperText, null, "Default value for this field")));
    }
};
FormInputDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], FormInputDetail);
let UserItemDetail = class UserItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Multi Select"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.multiselect, onChange: (e) => this.props.item.multiselect = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Enable disable multi select")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Add to user assigned task"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.addtotasks, onChange: (e) => this.props.item.addtotasks = e.currentTarget.checked })));
    }
};
UserItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], UserItemDetail);
let URLItemDetail = class URLItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")));
    }
};
URLItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], URLItemDetail);
let ObjectItemDetail = class ObjectItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")));
    }
};
ObjectItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ObjectItemDetail);
let RemoteItemDetail = class RemoteItemDetail extends React.Component {
    constructor(prop) {
        var _a, _b, _c;
        super(prop);
        const rtmap = new Map();
        if (this.props.item.rtextra !== undefined) {
            this.props.item.rtextra.forEach((ext) => rtmap.set(ext.cid, ext));
        }
        this.state = {
            sid: (_a = this.props.item.sid) !== null && _a !== void 0 ? _a : '',
            did: (_b = this.props.item.did) !== null && _b !== void 0 ? _b : '',
            cid: (_c = this.props.item.cid) !== null && _c !== void 0 ? _c : '',
            activecondition: '',
            conditions: [],
            rtextra: rtmap
        };
    }
    componentDidMount() {
        this.setState({ conditions: this.convertCondToUI() });
    }
    convertCondToUI() {
        var _a, _b, _c;
        const ret = [];
        const rstore = this.context;
        if (this.props.item.conds) {
            for (const cc of this.props.item.conds) {
                const cond = new RuleParamUICondition();
                cond.setPrevCond(cc.prevtype);
                cond.setCondition(cc.contype);
                for (const ccp of cc.params) {
                    const ck = new RuleParamUIConditionParam();
                    ck.setComp(ccp.comp);
                    ck.setLeftCond(ccp.leftcond);
                    ck.setRightCond(ccp.rightcond);
                    ck.setRightSchemaCol(ccp.rightschemacon);
                    if (ccp.leftcond) {
                        ck.activeschemaite = Array.from((_c = (_b = (_a = rstore.mainSchemaStore.anas.get(this.state.sid)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [])
                            .filter((item) => item.id === ccp.leftcond)[0];
                    }
                    cond.addCondParam(ck);
                }
                ret.push(cond);
            }
        }
        return ret;
    }
    render() {
        var _a, _b, _c;
        const rstore = this.context;
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(Box, { mt: '5px' },
                React.createElement(Flex, { w: '100%', align: 'center' },
                    React.createElement(Text, { fontWeight: 'bold', fontSize: 12 }, "Datasheet"),
                    React.createElement(Observer, null, () => React.createElement(Select, { placeholder: 'Select Datasheet', size: 'sm', value: this.state.did, onChange: (e) => {
                            if (e.currentTarget.value === this.state.did)
                                return;
                            this.setState({ did: e.currentTarget.value, sid: '', cid: '' });
                            this.props.item.did = e.currentTarget.value;
                            this.props.item.sid = "";
                        }, w: '200px', ml: '5px' }, Array.from(rstore.datasheetStore.schemas.values())
                        .map(dt => React.createElement("option", { key: dt.id, value: dt.id }, dt.name))))),
                this.state.did !== '' && React.createElement(Flex, { mt: '5px', w: '100%', align: 'center' },
                    React.createElement(Text, { fontWeight: 'bold', fontSize: 12 }, "Schema"),
                    React.createElement(Observer, null, () => {
                        var _a, _b, _c, _d;
                        return React.createElement(Select, { placeholder: 'Select Worksheet', size: 'sm', value: this.state.sid, onChange: (e) => {
                                if (e.currentTarget.value === this.state.sid)
                                    return;
                                this.setState({ sid: e.currentTarget.value, cid: '' });
                                this.props.item.sid = e.currentTarget.value;
                            }, w: '200px', ml: '16px' }, Array.from((_d = (_c = Array.from((_b = (_a = rstore.mainSchemaStore.anasschema.get(this.state.did)) === null || _a === void 0 ? void 0 : _a.values()) !== null && _b !== void 0 ? _b : [])
                            .sort((a1, a2) => { var _a, _b, _c, _d; return ((_b = (_a = a1.schemaopen) === null || _a === void 0 ? void 0 : _a.name.toLowerCase()) !== null && _b !== void 0 ? _b : '').localeCompare((_d = ((_c = a2.schemaopen) === null || _c === void 0 ? void 0 : _c.name.toLowerCase())) !== null && _d !== void 0 ? _d : ''); })) === null || _c === void 0 ? void 0 : _c.map((an) => an.schemaopen)) !== null && _d !== void 0 ? _d : [])
                            .filter(dt => dt !== undefined)
                            .map(dt => { var _a, _b, _c; return React.createElement("option", { key: (_a = dt === null || dt === void 0 ? void 0 : dt.id) !== null && _a !== void 0 ? _a : '', value: (_b = dt === null || dt === void 0 ? void 0 : dt.id) !== null && _b !== void 0 ? _b : '' }, (_c = dt === null || dt === void 0 ? void 0 : dt.name) !== null && _c !== void 0 ? _c : 'Missing'); }));
                    })),
                this.state.sid !== '' && React.createElement(Flex, { mt: '5px', w: '100%', align: 'center' },
                    React.createElement(Text, { fontWeight: 'bold', fontSize: 12 }, "Column1"),
                    React.createElement(Observer, null, () => {
                        var _a, _b, _c;
                        return React.createElement(Select, { placeholder: 'Select Column', size: 'sm', value: this.state.cid, onChange: (e) => {
                                var _a, _b;
                                if (e.currentTarget.value === this.state.cid)
                                    return;
                                this.setState({ cid: e.currentTarget.value });
                                this.props.item.cid = e.currentTarget.value;
                                const dtitems = (_b = (_a = rstore.mainSchemaStore.anas.get(this.state.sid)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.items;
                                console.log("ditems");
                                console.log(dtitems);
                                if (dtitems !== undefined) {
                                    for (const itm of dtitems) {
                                        if (itm.id === e.currentTarget.value) {
                                            this.setState({ type: itm.type });
                                            break;
                                        }
                                    }
                                }
                            }, w: '200px', ml: '16px' }, Array.from((_c = (_b = (_a = rstore.mainSchemaStore.anas.get(this.state.sid)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [])
                            .filter(dt => [SchemaItemType.Date, SchemaItemType.Text, SchemaItemType.Choice,
                            SchemaItemType.FormInput].indexOf(dt.type) !== -1)
                            .map(dt => { var _a, _b, _c; return React.createElement("option", { key: (_a = dt === null || dt === void 0 ? void 0 : dt.id) !== null && _a !== void 0 ? _a : '', value: (_b = dt === null || dt === void 0 ? void 0 : dt.id) !== null && _b !== void 0 ? _b : '' }, (_c = dt === null || dt === void 0 ? void 0 : dt.name) !== null && _c !== void 0 ? _c : 'Missing'); }));
                    })),
                this.state.cid !== '' && this.state.type !== undefined && this.state.type !== SchemaItemType.Choice && React.createElement(Box, null,
                    React.createElement(Text, null, 'Other Fields'),
                    Array.from((_c = (_b = (_a = rstore.mainSchemaStore.anas.get(this.state.sid)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : []).filter((item) => item.type !== SchemaItemType.List &&
                        (item.type === SchemaItemType.Text || item.type === SchemaItemType.FormInput || item.type === SchemaItemType.Objects) && item.id !== this.state.cid).map((val) => {
                        var _a;
                        return React.createElement(Tag, { key: val.id, margin: '4px', bg: ((_a = this.state.rtextra) === null || _a === void 0 ? void 0 : _a.has(val.id)) ? AppColor.SideBarIconColor : '#EDF2F7', _hover: { cursor: 'pointer' }, onClick: () => {
                                var _a;
                                let rtextra = (_a = this.state.rtextra) !== null && _a !== void 0 ? _a : new Map();
                                if (!rtextra.has(val.id)) {
                                    rtextra.set(val.id, { cid: val.id, name: val.name, isObject: val.type === SchemaItemType.Objects });
                                }
                                else {
                                    rtextra.delete(val.id);
                                }
                                this.setState({ rtextra: rtextra });
                                this.props.item.rtextra = Array.from(this.state.rtextra.values());
                            } },
                            React.createElement(TagLabel, null, val.name));
                    })),
                this.state.cid != '' && React.createElement(Box, null,
                    React.createElement(Flex, { mt: '4px' },
                        React.createElement(Observer, null, () => React.createElement(Select, { width: '120px', placeholder: 'Select Condition', value: this.state.activecondition, onChange: (e) => {
                                const evalu = e.currentTarget.value;
                                this.setState({ activecondition: evalu });
                            } },
                            React.createElement("option", { value: 'and' }, "And"),
                            React.createElement("option", { value: 'or' }, "Or"))),
                        React.createElement(Button, { ml: '5px', onClick: () => {
                                var _a, _b;
                                const evalu = this.state.activecondition;
                                if (evalu === 'and') {
                                    const rcon = new RuleParamUICondition();
                                    rcon.setCondition(ConditionType.And);
                                    rcon.setPrevCond(ConditionType.And);
                                    const rcon1 = {
                                        contype: ConditionType.And,
                                        prevtype: ConditionType.And,
                                        params: []
                                    };
                                    if (!this.props.item.conds) {
                                        this.props.item.conds = [];
                                    }
                                    const conds = this.state.conditions;
                                    conds.push(rcon);
                                    this.setState({ conditions: conds });
                                    (_a = this.props.item.conds) === null || _a === void 0 ? void 0 : _a.push(rcon1);
                                }
                                else if (evalu === 'or') {
                                    const rcon = new RuleParamUICondition();
                                    rcon.setCondition(ConditionType.Or);
                                    rcon.setPrevCond(ConditionType.Or);
                                    const rcon1 = {
                                        contype: ConditionType.Or,
                                        prevtype: ConditionType.Or,
                                        params: []
                                    };
                                    if (!this.props.item.conds) {
                                        this.props.item.conds = [];
                                    }
                                    const conds = this.state.conditions;
                                    conds.push(rcon);
                                    this.setState({ conditions: conds });
                                    (_b = this.props.item.conds) === null || _b === void 0 ? void 0 : _b.push(rcon1);
                                }
                            } }, "Add Condition")),
                    this.state.conditions.length > 0 && this.state.conditions.map((con, index) => React.createElement(Box, { key: index, mt: '5px', w: '80%', borderRadius: '10px', padding: '5px', borderWidth: '1px', borderColor: 'lightgray' },
                        React.createElement(Flex, { w: '100%', justify: 'flex-end', align: 'center', _hover: { cursor: 'pointer' }, onClick: () => {
                                var _a;
                                const rs = [...this.state.conditions];
                                rs.splice(index, 1);
                                this.setState({ conditions: rs });
                                (_a = this.props.item.conds) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
                            } },
                            React.createElement(Icon, { ml: '10px', as: MdDelete })),
                        index > 0 && React.createElement(Flex, null,
                            React.createElement(Text, null, "Result from previous stage"),
                            React.createElement(Observer, null, () => React.createElement(Select, { value: con.prevresult === ConditionType.And ? 'and' : 'or', onChange: (e) => {
                                    if (e.currentTarget.value === 'and') {
                                        con.setPrevCond(ConditionType.And);
                                        if (this.props.item.conds)
                                            this.props.item.conds[index].prevtype = ConditionType.And;
                                    }
                                    else {
                                        if (this.props.item.conds)
                                            this.props.item.conds[index].prevtype = ConditionType.Or;
                                        con.setPrevCond(ConditionType.Or);
                                    }
                                } },
                                React.createElement("option", { value: 'and', key: 'and' }, "And"),
                                React.createElement("option", { value: 'or' }, "Or")))),
                        React.createElement(Flex, { mt: '4px', w: '100%', align: 'center', justify: 'center' },
                            React.createElement(Text, { fontWeight: 'bold' }, con.condtype === ConditionType.And ? 'AND BLOCK' : 'OR BLOCK')),
                        React.createElement(Flex, { w: '100%', align: 'center' },
                            React.createElement(Button, { onClick: (e) => {
                                    var _a;
                                    const param = new RuleParamUIConditionParam();
                                    con.addCondParam(param);
                                    (_a = this.props.item.conds) === null || _a === void 0 ? void 0 : _a[index].params.push({
                                        leftcond: '',
                                        rightcond: '',
                                        rightschemacon: '',
                                        comp: Comparator.Equal
                                    });
                                }, ml: '4px' }, "Add Param")),
                        React.createElement(Box, { mt: '5px', w: '100%' }, con.conditionparam.map((param, mindex) => {
                            var _a, _b;
                            return React.createElement(Box, { key: mindex + "", w: '100%' },
                                mindex > 0 && React.createElement(Flex, { w: '100%', align: 'center', justify: 'center' },
                                    React.createElement(Text, { fontWeight: 'bold' }, con.condtype === ConditionType.And ? 'AND' : 'OR')),
                                React.createElement(Flex, { w: '100%', align: 'center', justify: 'flex-end' },
                                    React.createElement(Icon, { as: MdDelete, onClick: () => {
                                            var _a;
                                            con.removeCondParam(mindex);
                                            (_a = this.props.item.conds) === null || _a === void 0 ? void 0 : _a[index].params.splice(mindex, 1);
                                        } })),
                                React.createElement(Observer, null, () => {
                                    var _a, _b, _c;
                                    return React.createElement(Select, { value: param.leftcondition, placeholder: 'Select Column', onChange: (e) => {
                                            var _a, _b, _c;
                                            // we need to now select and also do the type of the condtion as well
                                            param.setRightCond("");
                                            param.activeschemaite = Array.from((_c = (_b = (_a = rstore.mainSchemaStore.anas.get(this.state.sid)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [])
                                                .filter((item) => item.id === e.currentTarget.value)[0];
                                            param.setLeftCond(e.currentTarget.value);
                                            if (this.props.item.conds)
                                                this.props.item.conds[index].params[mindex].leftcond = e.currentTarget.value;
                                        } }, Array.from((_c = (_b = (_a = rstore.mainSchemaStore.anas.get(this.state.sid)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : []).filter((item) => item.type !== SchemaItemType.List &&
                                        item.type !== SchemaItemType.Objects && item.id !== this.state.cid).map((val) => React.createElement("option", { key: val.id, value: val.id }, val.name)));
                                }),
                                param.leftcondition !== '' && param.activeschemaite !== undefined && React.createElement(Observer, null, () => {
                                    var _a;
                                    return React.createElement(Select, { mt: '5px', value: param.comp, onChange: e => {
                                            const scom = e.currentTarget.value;
                                            param.setComp(Comparator[scom]);
                                            if (this.props.item.conds)
                                                this.props.item.conds[index].params[mindex].comp = Comparator[scom];
                                        }, placeholder: 'Select Comparator' }, param.getCompsFor((_a = param.activeschemaite) === null || _a === void 0 ? void 0 : _a.type).map((com) => React.createElement("option", { value: com, key: com }, com)));
                                }),
                                param.leftcondition !== '' && param.comp !== undefined
                                    &&
                                        param.activeschemaite !== undefined
                                    && React.createElement(Box, { mt: '5px' },
                                        param.activeschemaite.type === SchemaItemType.Date && React.createElement(DateInput, { onChange: (e) => {
                                                param.setRightCond(e + '');
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e + '';
                                            }, disabledate: (_a = param.activeschemaite.excludedate) !== null && _a !== void 0 ? _a : false, defaultvalue: param.rightcondition !== '' ?
                                                parseInt(param.rightcondition) : 0, use24hrformat: param.activeschemaite.use24hrformat, key: index + "_cond", id: param.activeschemaite.id, format: (_b = param.activeschemaite.format) !== null && _b !== void 0 ? _b : 'dd/MM/yyyy', showtime: param.activeschemaite.inlcudetime }),
                                        param.activeschemaite.type === SchemaItemType.Choice && React.createElement(ChoiceInput, { id: index + "_cond", key: index + "_cond", defaultvalue: param.rightcondition, list: param.activeschemaite.items, onChange: (e) => {
                                                param.setRightCond(e);
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e;
                                            } }),
                                        param.activeschemaite.type === SchemaItemType.Color && React.createElement(ColorInput, { id: param.activeschemaite.id, defaultvalue: param.rightcondition, onChange: (e) => {
                                                param.setRightCond(e);
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e;
                                            } }),
                                        param.activeschemaite.type === SchemaItemType.UserChoice && React.createElement(ChoiceInput, { id: index + "_cond", key: index + "_cond", defaultvalue: param.rightcondition, onChange: (e) => {
                                                param.setRightCond(e);
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e;
                                            }, list: [...rstore.letrAndTagStore.actveltermembers.map((mem) => ({ id: mem.id, name: mem.name + " (" + mem.orgname + ")", type: ChoiceType.Text })),
                                                ...Array.from(rstore.letrDetailStore.letrlinks.values()).map((link) => ({ id: "freesoul-" + link.id, name: link.name + " (External Link)", type: ChoiceType.Text }))] }),
                                        param.activeschemaite.type === SchemaItemType.Number && React.createElement(Input, { value: param.rightcondition, onChange: (e) => {
                                                param.setRightCond(e.currentTarget.value);
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e.currentTarget.value;
                                            }, key: index + "_cond", type: 'number' }),
                                        param.activeschemaite.type === SchemaItemType.Text && React.createElement(Input, { value: param.rightcondition, key: index + "_cond", onChange: (e) => {
                                                param.setRightCond(e.currentTarget.value);
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e.currentTarget.value;
                                            } }),
                                        param.activeschemaite.type === SchemaItemType.FormInput && React.createElement(Input, { value: param.rightcondition, key: index + "_cond", onChange: (e) => {
                                                param.setRightCond(e.currentTarget.value);
                                                if (this.props.item.conds)
                                                    this.props.item.conds[index].params[mindex].rightcond = e.currentTarget.value;
                                            } })));
                        })))))));
    }
};
RemoteItemDetail.contextType = StoreContext;
RemoteItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RemoteItemDetail);
let IDItemDetail = class IDItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            length: 0
        };
    }
    render() {
        var _a;
        const rstore = this.context;
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "ID Length"),
                React.createElement(Input, { type: 'number', defaultValue: (_a = this.props.item.defaultvalue) !== null && _a !== void 0 ? _a : '', isInvalid: this.state.length < 4 ? true : false, errorBorderColor: 'red.300', onChange: (e) => {
                        const ln = parseInt(e.currentTarget.value.trim());
                        this.setState({ length: ln });
                        if (!isNaN(ln)) {
                            this.props.item.length = ln;
                        }
                    } }),
                React.createElement(FormHelperText, null, "Length for the id")));
    }
};
IDItemDetail.contextType = StoreContext;
IDItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], IDItemDetail);
let TextItemDetail = class TextItemDetail extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        var _a;
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Rich Text"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.richtext, onChange: (e) => this.props.item.richtext = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Use rich text editor for this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Default Value"),
                React.createElement(Input, { defaultValue: (_a = this.props.item.defaultvalue) !== null && _a !== void 0 ? _a : '', onChange: (e) => {
                        this.props.item.defaultvalue = e.currentTarget.value.trim();
                    } }),
                React.createElement(FormHelperText, null, "Default value for this field")));
    }
};
TextItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], TextItemDetail);
let DateInput = class DateInput extends React.Component {
    constructor(prop) {
        super(prop);
        let date;
        if (prop.defaultvalue) {
            if (this.props.defaultvalue) {
                try {
                    date = new Date(this.props.defaultvalue);
                }
                catch (e) {
                }
            }
        }
        this.state = {
            date: date
        };
    }
    render() {
        return React.createElement(Box, null,
            React.createElement(DatePicker, { showTimeInput: this.props.showtime, showTimeSelectOnly: this.props.disabledate, selected: this.state.date, dateFormat: (!this.props.disabledate ? this.props.format : "") + "" + (this.props.showtime ? " HH:mm" : ''), onChange: (date) => {
                    this.props.onChange(date.getTime());
                    this.setState({ date: date });
                } }));
    }
};
DateInput.contextType = StoreContext;
DateInput = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DateInput);
let ColorInput = class ColorInput extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            color: this.props.defaultvalue
        };
    }
    convertRGBToString(rgb) {
        return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")";
    }
    convertRGBStringToRGB(rgb) {
        const clerstr = rgb.replace("rgba(", "").replace(")", "");
        const parts = clerstr.split(",");
        return { r: parseInt(parts[0]), g: parseInt(parts[1]), b: parseInt(parts[2]), a: parseFloat(parts[3]) };
    }
    render() {
        return React.createElement(Box, null,
            this.state.color !== '' && React.createElement(Box, { mb: '5px', w: '20px', h: '20px', borderRadius: '10px', bg: this.state.color }),
            !this.props.hidelbl && this.state.color === '' && React.createElement(Box, { mb: '5px' },
                React.createElement(Text, null, "Select Color")),
            React.createElement(SketchPicker, { color: this.convertRGBStringToRGB(this.state.color), onChange: ({ rgb }) => {
                    const cl = this.convertRGBToString(rgb);
                    this.props.onChange(cl);
                    this.setState({ color: cl });
                } }));
    }
};
ColorInput.contextType = StoreContext;
ColorInput = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ColorInput);
let ChoiceInput = class ChoiceInput extends React.Component {
    constructor(prop) {
        super(prop);
    }
    render() {
        return React.createElement(Box, { key: this.props.id },
            React.createElement(Observer, null, () => React.createElement(Select, { placeholder: 'Select', defaultValue: this.props.defaultvalue, onChange: (e) => this.props.onChange(e.currentTarget.value) }, this.props.list.map((item) => React.createElement("option", { key: item.id, value: item.id }, item.name)))));
    }
};
ChoiceInput.contextType = StoreContext;
ChoiceInput = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], ChoiceInput);
let NumberItemDetail = class NumberItemDetail extends React.Component {
    constructor(prop) {
        var _a;
        super(prop);
        this.state = {
            minv: this.props.item.minvalue + '',
            maxv: this.props.item.maxvalue + '',
            dval: (_a = this.props.item.defaultvalue) !== null && _a !== void 0 ? _a : ''
        };
    }
    render() {
        return React.createElement(Box, { w: '100%', h: '100%' },
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Field Name"),
                React.createElement(Input, { defaultValue: this.props.item.name, onChange: (e) => {
                        if (e.currentTarget.value.trim()) {
                            this.props.item.name = e.currentTarget.value.trim();
                        }
                    } }),
                React.createElement(FormHelperText, null, "Title of this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Required"),
                React.createElement(Checkbox, { defaultChecked: this.props.item.required, onChange: (e) => this.props.item.required = e.currentTarget.checked }),
                React.createElement(FormHelperText, null, "Is this field mandatory for each new row")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Min Value"),
                React.createElement(Input, { type: 'number', value: this.state.minv, onChange: (e) => {
                        if (e.currentTarget.value === '') {
                            this.setState({ minv: '' });
                            this.props.item.minvalue = undefined;
                            return;
                        }
                        this.setState({ minv: e.currentTarget.value });
                        try {
                            if (e.currentTarget.value.indexOf(".") !== -1) {
                                this.props.item.minvalue = parseFloat(e.currentTarget.value);
                            }
                            else {
                                this.props.item.minvalue = parseInt(e.currentTarget.value);
                            }
                        }
                        catch (ex) {
                        }
                    } }),
                React.createElement(FormHelperText, null, "Min value for this field")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Max Value"),
                React.createElement(Input, { type: 'number', value: this.state.maxv, onChange: (e) => {
                        if (e.currentTarget.value === '') {
                            this.setState({ maxv: '' });
                            this.props.item.maxvalue = undefined;
                            return;
                        }
                        this.setState({ maxv: e.currentTarget.value });
                        try {
                            if (e.currentTarget.value.indexOf(".") !== -1) {
                                this.props.item.maxvalue = parseFloat(e.currentTarget.value);
                            }
                            else {
                                this.props.item.maxvalue = parseInt(e.currentTarget.value);
                            }
                        }
                        catch (ex) {
                        }
                    } }),
                React.createElement(FormHelperText, null, "Max value for this field.")),
            React.createElement(FormControl, null,
                React.createElement(FormLabel, null, "Default Value"),
                React.createElement(Input, { type: 'number', value: this.state.dval, onChange: (e) => {
                        if (e.currentTarget.value === '') {
                            this.setState({ dval: '' });
                            this.props.item.defaultvalue = undefined;
                            return;
                        }
                        this.props.item.defaultvalue = e.currentTarget.value;
                        this.setState({ dval: e.currentTarget.value });
                    } }),
                React.createElement(FormHelperText, null, "Default value for this field")));
    }
};
NumberItemDetail = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], NumberItemDetail);
